import { useState } from "react";
import type { ForumIdentity } from "../hooks/useForumIdentity";
import { useWallet } from "../wallet/WalletContext";

/**
 * "Posting as …" strip above every composer. Three states, in order of
 * how much the visitor has committed:
 *   - wallet connected  -> posts under the WAX account, nothing to choose
 *   - guest name saved  -> posts under that name, editable here
 *   - nothing           -> posts land as "anon", and that's allowed
 * The whole point of the forum is that state three works, so this never
 * blocks the composer — it just offers the upgrade.
 */
export function ForumIdentityBar({ identity }: { identity: ForumIdentity }) {
  const { connect, connecting } = useWallet();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(identity.guestName);

  if (identity.isWallet) {
    return (
      <div className="forum-identity">
        Posting as <strong>{identity.account}</strong> <span className="forum-post__badge">WAX</span>
      </div>
    );
  }

  return (
    <div className="forum-identity">
      {editing ? (
        <>
          <input
            type="text"
            value={draft}
            maxLength={24}
            placeholder="Display name"
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                identity.setGuestName(draft);
                setEditing(false);
              }
            }}
          />
          <button
            className="btn btn--small btn--primary"
            onClick={() => {
              identity.setGuestName(draft);
              setEditing(false);
            }}
          >
            Save
          </button>
          <button className="btn btn--small btn--outline" onClick={() => setEditing(false)}>
            Cancel
          </button>
        </>
      ) : (
        <>
          Posting as <strong>{identity.guestName || "anon"}</strong>
          <button className="link-button" onClick={() => setEditing(true)}>
            {identity.guestName ? "change name" : "pick a name"}
          </button>
          <span className="forum-identity__sep">·</span>
          <button className="link-button" onClick={connect} disabled={connecting}>
            {connecting ? "connecting…" : "connect wallet"}
          </button>
        </>
      )}
    </div>
  );
}
